
const assetsPath = "https://proofpoint-roi-calc.s3-us-west-1.amazonaws.com";

export default {
  "fields": {
    "title": "Insider Threat Management ROI Calculator",
    "banner_image": {
      "url": `${assetsPath}/images/IRM_Calculator_page_banner_1200x300_v3.jpg`,
    },
    "google_api_key": "AIzaSyA7S9tkI1O27YfKnTfzyJlfwCcEvwNlVNk",
    "google_sheet_id": "1RSjHkD9dxKIM5Ym8ZJuA9p1WjRS40QSZoaWXavQDmw0",
    "pdf_header_image": {
      "url": `${assetsPath}/images/IRM_Calculator_926x183.png`,
    },
    "pdf_costs_image": {
      "url": `${assetsPath}/images/2020-cost-report.jpg`,
    },
    "pdf_analyze_image": {
      "url": `${assetsPath}/images/economy_analysis.jpg`,
    },
    "pdf_frequency_image": {
      "url": `${assetsPath}/images/frequency-chart.jpg`,
    },
    "pdf_costs_and_industry_image": {
      "url": `${assetsPath}/images/industry-costs.jpg`,
    },
    "pdf_key_cost_drivers_image": {
      "url": `${assetsPath}/images/key-cost-drivers.jpg`,
    },
    "background_color": "",
    "background_image": false,
    "background_size": "cover",
    "background_position": "",
    "background_attachment": "scroll",
    "background_repeat": "no-repeat",
    "color": "",
    "margin": "",
    "padding": "",
    "content_in_container": false
  },
  "attributes": {
    "class": [
      "theme-block",
      "theme-block--roi-calculator",
      "b-roi-calculator",
      "theme-block--full",
      "theme-block--live"
    ],
    "style": [],
    "data-vue-component": "roi-calculator"
  },
  "pdf_endpoint": "/api/roi-calculator-pdf",
  "font_base": `${assetsPath}/fonts`,
  "nonce": "e82b68d5b2",
  "is_preview": false,
  "index": 0
}; 
